export function linkToHome() {
  return "/";
}

export function linkToSignOut() {
  return "/sign-out";
}

export function linkToUnauthorized() {
  return "/unauthorized";
}

export function linkTo404() {
  return "/404";
}
